import type React from 'react';

import { IconExclamationCircle } from '../Icon';
import { Icon, Text, Wrapper } from './wrapper';

interface Props {
  children: React.ReactNode;
}

const InputError = ({ children }: Props) => (
  <Wrapper>
    <Icon>
      <IconExclamationCircle />
    </Icon>
    <Text>{children}</Text>
  </Wrapper>
);

export default InputError;
